export default __webpack_public_path__ + "static/media/logo.52275ee3.svg";